<header>
  <h1 *ngIf="pageTitle" class="bl-screen-reader-only"> {{ pageTitle }} </h1>
  <div class="bl-display--flex bl-align-items--flex-start">
    <p *ngIf="pagesubTitle" class="bl-flex--auto bl-font-color--steel bl-padding-x--8">{{ pagesubTitle }}</p>
    <!-- TODO: confirm if we still use this button? -->
    <!-- This seems to be used for 2 co-app pages on OAO non-youth memberships -->
    <div *ngIf="showRemove" class="bl-display--flex bl-justify-content--flex-end bl-margin-bottom--16">
      <button class="bl-button bl-button-tertiary" (click)="page.remove()" title="Remove Applicant" id="remove-oao-applicant">
        <i class="cu-trash-can"></i> Remove Applicant
      </button>
    </div>
  </div>
</header>

<ea-alert [ngClass]="{'bl-margin-bottom--16 bl-display--block': showResumeBanner}" [showAlert]="showResumeBanner"
  alertId="resume-banner" alertStatus="info" [useNgContent]="true">
  {{ 'pageHeader/resumeBannerText' | dictionary }}
  <a [routerLink]="loggedIn ? ['/consumer/dashboard'] : ['/user/login']" [queryParams]="loggedIn ? {return: 'dashboard'} : {}">
    {{ loggedIn ? ('pageHeader/resumeBannerLinkAlternate' | dictionary) : ('pageHeader/resumeBannerLink' | dictionary)}}
  </a>
</ea-alert>

<ea-alert [ngClass]="{'bl-margin-bottom--16 bl-display--block': showYouthNoteBanner}" [showAlert]="showYouthNoteBanner"
  alertId="youth-banner" alertStatus="info" [useNgContent]="true">
  {{ 'pageHeader/youthNoteBannerText' | dictionary }}
</ea-alert>